import { stringToDateObject } from "./string";

export function getDateValue(value: any) {
  return value
    ? typeof value === "string"
      ? stringToDateObject(value)
      : value
    : null;
}
